import React from 'react';
import { useMobileView } from '../../useMobileView';
import { ButtonV2, SpacingStack } from '@withjoy/joykit';
import { MobileGuestSubMenu } from '../MobileGuestSubMenu';
import { Wrapper, ButtonContainer, styles } from './MobileGuestMenu.styles';

export const MobileGuestMenu: React.FC = () => {
  const { topLevelLinks, resourceRedirectLinks } = useMobileView();
  return (
    <Wrapper {...styles.wrapper}>
      <SpacingStack
        spacing={6}
        paddingX={6}
      >
        {resourceRedirectLinks.map(props => (
          <MobileGuestSubMenu
            key={props.type + props.heading}
            {...props}
          />
        ))}
      </SpacingStack>
      <ButtonContainer {...styles.suttonContainer}>
        <ButtonV2
          variant="solid"
          intent="neutral"
          width="100%"
          as="a"
          href={topLevelLinks.getStarted.href}
          target={topLevelLinks.getStarted.target}
          onClick={topLevelLinks.getStarted.onClick}
        >
          {topLevelLinks.getStarted.label}
        </ButtonV2>
        <ButtonV2
          variant="outline"
          intent="neutral"
          width="100%"
          as="a"
          href={topLevelLinks.login.href}
          target={topLevelLinks.login.target}
          onClick={topLevelLinks.login.onClick}
        >
          {topLevelLinks.login.label}
        </ButtonV2>
        <ButtonV2
          variant="ghost"
          intent="neutral"
          width="100%"
          as="a"
          href={topLevelLinks.findACouple.href}
          target={topLevelLinks.findACouple.target}
          onClick={topLevelLinks.findACouple.onClick}
        >
          {topLevelLinks.findACouple.label}
        </ButtonV2>
      </ButtonContainer>
    </Wrapper>
  );
};
